import { createContext, useContext } from "react";
import ConstrainedView from "../../components/reactOL/views/ConstrainedView";
import * as olProj from "ol/proj";

export interface ViewContextType {
  view: ConstrainedView;
  projection: olProj.Projection;
  tileGrid: any;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}
const ViewContext = createContext<ViewContextType | undefined>(undefined);

const useViewContext = () => {
  const context = useContext(ViewContext);

  if (context === undefined) {
    throw new Error("useViewContext was used outside of its Provider");
  }

  return context;
};

export { ViewContext, useViewContext };
